import '../../styles/tile-select.css'
import {useEffect, useRef, useState} from "react";
import {Button, Checkbox, Form, InputNumber, Popover, Tabs} from "antd";
import AppColor from "../../components/AppColor";
import {AppActions, Bounding, FlowArrow, TerrainLayer, useAppContext} from "../../context/AppContext";
import {
    MinusOutlined,
    PlusOutlined,
    RadiusBottomleftOutlined,
    RadiusBottomrightOutlined,
    RadiusUpleftOutlined,
    RadiusUprightOutlined
} from "@ant-design/icons";
import ShapeTable from "../map/ShapeTable";
import {useModal} from "../../context/ModalContext";
import ShapeFileHelper from "../../helpers/ShapeFileHelper";
import {v4} from "uuid";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";

export const Layers = [
    'Mannings n',
    'Bank Station',
    'Ineffective Area',
    'Blocked Obstruction',
    'Multiple Opening',
    'Flood Extent',
    'Flow Direction',
    'Flow Change Location',
    'Flow Path',
    'Boundary Condition',
]

const ReferenceLayers = [
    {name: 'US Counties Light', file: 'cb_2018_us_county_20m.kml'},
    {name: 'US Counties HD', file: 'cb_2018_us_county_500k.kml'},
    {name: 'NC FIRM Panel Effective', file: 'nc_firm.kml'},
    {name: 'NC Political Areas', file: 'political.kml'},
]

const getLayers = (context, type, layerName) => {
    if(context && context[type] && context[type]?.selectedLayers) {
        return context[type]?.selectedLayers[layerName]
    }

    return []
}

export default function ({type, projectLayers, onUpdate, onProjectLayerChange, riverBounding}) {
    const {mapContext, dispatchProject, appContext, getSelectedHistory, getMapData} = useAppContext()
    const [modelLayers, setModelLayers] = useState([...getLayers(mapContext, type, 'model')])
    const [referenceLayers, setReferenceLayers] = useState([...getLayers(mapContext, type, 'reference')])
    const [projLayers, setProjLayers] = useState([...getLayers(mapContext, type, 'project')])
    const formRef = useRef()
    const {modal} = useModal()
    const [popoverOpen, setPopoverOpen] = useState(false)
    const [bounding, setBounding] = useState([])
    const debounceRef = useRef(null)

    useEffect(() => {
        update()
    }, [modelLayers, referenceLayers, projLayers])

    const update = () => {
        if(debounceRef.current)
            clearTimeout(debounceRef.current)

        debounceRef.current = setTimeout(() => {
            const bounding = formRef?.current?.getFieldsValue() || Bounding
            const flowArrow = formRef?.current?.getFieldsValue() || FlowArrow
            const terrainLayers = formRef?.current?.getFieldsValue() || TerrainLayer

            dispatchProject({
                type: AppActions.SET_MAP_CONTEXT,
                data: {
                    map: {
                        ...mapContext,
                        [type]: {
                            ...mapContext[type],
                            update: v4(),
                            bounding: {
                                showBounding: bounding?.showBounding,
                                northWest: bounding?.northWest,
                                northEast: bounding?.northEast,
                                southWest: bounding?.southWest,
                                southEast: bounding?.southEast,
                            },
                            flowArrow: {
                                flow_count: flowArrow?.flow_count,
                                flow_size: flowArrow?.flow_count,
                                flow_change_size: flowArrow?.flow_change_size,
                                boundary_size: flowArrow?.boundary_size,
                            },
                            selectedLayers: {
                                model: [...modelLayers],
                                reference: [...referenceLayers],
                                project: [...projLayers],
                            },
                            terrainLayers: {
                                resolution_size: terrainLayers?.resolution_size,
                                opacity_size: terrainLayers?.opacity_size,
                                gray_opacity_size: terrainLayers?.gray_opacity_size,
                                gray_z_factor: terrainLayers?.gray_z_factor,
                            }
                        }
                    }
                }
            })
        }, 500)
    }

    useEffect(() => {
        (async () => {
            const _b = await ShapeFileHelper.getBounding(riverBounding || [], mapContext[type]?.bounding)
            setBounding(_b)
        })()
    }, [mapContext[type]?.bounding]);

    return (
        <>
            <Popover
                placement={'bottomRight'}
                trigger={'click'}
                open={popoverOpen && !modal.open}
                onVisibleChange={(visible) => {
                    if(!modal.open) {
                        setPopoverOpen(visible)
                    }
                }}
                overlayStyle={{padding: 0}}
                content={(
                    <div style={{width: 993}}>
                        <Tabs>
                            <Tabs.TabPane tab={'Layers'} key={'Layers'}>
                                <div style={{display: 'flex', alignItems: 'start', gap: 8}}>
                                    <div>
                                        <div
                                            style={{backgroundColor: AppColor.secondColor, width: 225, paddingLeft: 4}}>
                                            Model Layers
                                        </div>
                                        <table>
                                            <tbody>
                                            {
                                                Layers.map(x => (
                                                    <tr>
                                                        <td>
                                                            <Checkbox
                                                                checked={modelLayers.includes(x)} value={x}
                                                                style={{paddingLeft: 0}}
                                                                onChange={(e) => {
                                                                    if (!e.target.checked) {
                                                                        setModelLayers(modelLayers.filter(y => y !== x))
                                                                    } else {
                                                                        modelLayers.push(x)
                                                                        setModelLayers([...modelLayers])
                                                                    }
                                                                }}
                                                            >
                                                                {x}
                                                            </Checkbox>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                            </tbody>
                                        </table>
                                        <div style={{
                                            backgroundColor: AppColor.secondColor,
                                            width: 225,
                                            paddingLeft: 4,
                                            marginTop: 12
                                        }}>
                                            Reference Layers
                                        </div>
                                        <table>
                                            <tbody>
                                            {
                                                ReferenceLayers.map(x => (
                                                    <tr>
                                                        <td>
                                                            <Checkbox
                                                                checked={referenceLayers.find(y => y.name === x.name)}
                                                                value={x.name}
                                                                style={{paddingLeft: 0}}
                                                                onChange={(e) => {
                                                                    if (!e.target.checked) {
                                                                        setReferenceLayers(referenceLayers.filter(y => y.name !== x.name))
                                                                    } else {
                                                                        referenceLayers.push(x)
                                                                        setReferenceLayers([...referenceLayers])
                                                                    }
                                                                }}
                                                            >
                                                                {x.name}
                                                            </Checkbox>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                    <>
                                        <div>
                                            <div style={{
                                                backgroundColor: AppColor.secondColor,
                                                width: '100%',
                                                paddingLeft: 4
                                            }}>
                                                Project Layers
                                            </div>
                                            <ShapeTable
                                                selectable={true}
                                                bounding={bounding}
                                                shapes={projectLayers}
                                                selectedLayers={projLayers}
                                                onSelected={(layers) => {
                                                    setProjLayers([...layers])
                                                }}
                                                onChange={onProjectLayerChange}
                                            />
                                        </div>
                                    </>
                                </div>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={'Settings'} key={'Layer Settings'}>
                                <Form
                                    labelAlign={'left'}
                                    size={'small'}
                                    layout={'horizontal'}
                                    ref={formRef}
                                    onChange={update}
                                    initialValues={{
                                        ...(mapContext[type]?.bounding),
                                        ...(mapContext[type]?.flowArrow),
                                        ...(mapContext[type]?.terrainLayers),
                                    }}
                                >
                                    <div style={{display: 'flex', alignItems: 'start', alignContent: 'start', gap: 12}}>
                                        <table style={{}}>
                                            <tbody>
                                            <tr>
                                                <ResultHeaderCell colSpan={5}>
                                                    Bounding Settings
                                                </ResultHeaderCell>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <RadiusUpleftOutlined/>
                                                </td>
                                                <td>
                                                    <Form.Item
                                                        style={{padding: 0, margin: 0}}
                                                        name={'northWest'}
                                                    >
                                                        <InputNumber/>
                                                    </Form.Item>
                                                </td>
                                                <td>
                                                    <RadiusUprightOutlined/>
                                                </td>
                                                <td>
                                                    <Form.Item
                                                        style={{padding: 0, margin: 0}}
                                                        name={'northEast'}
                                                    >
                                                        <InputNumber/>
                                                    </Form.Item>
                                                </td>
                                                <td>
                                                    <Button size={'small'} icon={<PlusOutlined/>}
                                                            onClick={() => {
                                                                const formData = formRef.current.getFieldsValue()
                                                                formRef.current.setFieldsValue({
                                                                    ...formData,
                                                                    northWest: formData.northWest + 25,
                                                                    northEast: formData.northEast + 25,
                                                                    southWest: formData.southWest + 25,
                                                                    southEast: formData.southEast + 25,
                                                                })
                                                                update()
                                                            }}/>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <RadiusBottomleftOutlined/>
                                                </td>
                                                <td>
                                                    <Form.Item
                                                        style={{padding: 0, margin: 0}}
                                                        name={'southWest'}
                                                    >
                                                        <InputNumber/>
                                                    </Form.Item>
                                                </td>
                                                <td>
                                                    <RadiusBottomrightOutlined/>
                                                </td>
                                                <td>
                                                    <Form.Item
                                                        style={{padding: 0, margin: 0}}
                                                        name={'southEast'}
                                                    >
                                                        <InputNumber/>
                                                    </Form.Item>
                                                </td>
                                                <td>
                                                    <Button.Group>
                                                        <Button size={'small'} icon={<MinusOutlined/>}
                                                                onClick={() => {
                                                                    const formData = formRef.current.getFieldsValue()
                                                                    formRef.current.setFieldsValue({
                                                                        ...formData,
                                                                        northWest: formData.northWest - 25,
                                                                        northEast: formData.northEast - 25,
                                                                        southWest: formData.southWest - 25,
                                                                        southEast: formData.southEast - 25,
                                                                    })
                                                                    update()
                                                                }}/>
                                                    </Button.Group>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={5}>
                                                    <div
                                                        style={{display: 'flex', alignItems: 'center', gap: 4}}>
                                                        <div style={{marginLeft: 4}}>
                                                            Show/Hide Bounding:
                                                        </div>
                                                        <Form.Item
                                                            style={{padding: 0, margin: 0}}
                                                            name={'showBounding'}
                                                            valuePropName={'checked'}
                                                        >
                                                            <Checkbox/>
                                                        </Form.Item>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <ResultHeaderCell>
                                                    Flow Arrow Settings
                                                </ResultHeaderCell>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Item
                                                        style={{padding: 0, margin: 0, textAlign: 'start'}}
                                                        label={(<div style={{width: 125}}>Count</div>)}
                                                        name={'flow_count'}
                                                    >
                                                        <InputNumber/>
                                                    </Form.Item>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Item
                                                        style={{padding: 0, margin: 0, textAlign: 'start'}}
                                                        label={(<div style={{width: 125}}>Size</div>)}
                                                        name={'flow_size'}
                                                    >
                                                        <InputNumber/>
                                                    </Form.Item>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <ResultHeaderCell>
                                                    Other Settings
                                                </ResultHeaderCell>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Item
                                                        style={{padding: 0, margin: 0, textAlign: 'start'}}
                                                        label={(<div style={{width: 125}}>Flow Change Size</div>)}
                                                        name={'flow_change_size'}
                                                    >
                                                        <InputNumber/>
                                                    </Form.Item>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Item
                                                        style={{padding: 0, margin: 0, textAlign: 'start'}}
                                                        label={(<div style={{width: 125}}>Boundary Size</div>)}
                                                        name={'boundary_size'}
                                                    >
                                                        <InputNumber/>
                                                    </Form.Item>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <ResultHeaderCell>
                                                    Terrain Layer Settings
                                                </ResultHeaderCell>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Item
                                                        style={{padding: 0, margin: 0, textAlign: 'start'}}
                                                        label={(<div style={{width: 125}}>Resolution Size</div>)}
                                                        name={'resolution_size'}
                                                    >
                                                        <InputNumber min={0} max={512}/>
                                                    </Form.Item>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Item
                                                        style={{padding: 0, margin: 0, textAlign: 'start'}}
                                                        label={(<div style={{width: 125}}>Opacity</div>)}
                                                        name={'opacity_size'}
                                                    >
                                                        <InputNumber min={0} max={1} step={0.1}/>
                                                    </Form.Item>
                                                </td>
                                            </tr>
                                            </tbody>
                                            <tr>
                                                <td>
                                                    <Form.Item
                                                        style={{padding: 0, margin: 0, textAlign: 'start'}}
                                                        label={(<div style={{width: 125}}>Hillshade Opacity</div>)}
                                                        name={'gray_opacity_size'}
                                                    >
                                                        <InputNumber min={0.1} max={10} step={0.1}/>
                                                    </Form.Item>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Item
                                                        style={{padding: 0, margin: 0, textAlign: 'start'}}
                                                        label={(<div style={{width: 125}}>Z Factor</div>)}
                                                        name={'gray_z_factor'}
                                                    >
                                                        <InputNumber min={0} max={1} step={0.1}/>
                                                    </Form.Item>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </Form>
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                )}
            >
                <Button
                    style={{width: 100}}
                    size={'small'}
                    onClick={() => {
                        setPopoverOpen(!popoverOpen)
                    }}
                >
                    Layers
                </Button>
            </Popover>
            {/*<Drawer*/}
            {/*    title="Basic Drawer"*/}
            {/*    placement={'left'}*/}
            {/*    closable={true}*/}
            {/*    open={true}*/}
            {/*>*/}
            {/*    <p>Some contents...</p>*/}
            {/*    <p>Some contents...</p>*/}
            {/*    <p>Some contents...</p>*/}
            {/*</Drawer>*/}
        </>
    )
}